import React, { useState, useEffect, useRef } from "react";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import { APICall } from "../../../helpers/API/APICalls";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import {
  getKnowledgeBaseMasterDataById,
  insertUpdateKnowledgeBaseMaster,
} from "../../../helpers/API/APIEndPoints";
import moment from "moment";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { useHistory, useParams } from "react-router-dom";
import {
  saveRecordMsg,
  updateRecordMsg,
} from "../../../helpers/Constants/Constants";
import { Button, Card, Form, Image, InputGroup } from "react-bootstrap";
import { del } from "../../../constants/Images";
import { Modal } from "@material-ui/core";
import ButtonForm from "../../../ReusableComponents/ButtonForm/ButtonForm";
import CreateKnowledgeService from "../../../services/CreateKnowledgeService";
import { downloadBlob } from "../../../services/CommonService";
import DeleteDialogueBox from "../../../ReusableComponents/DeleteDialogueBox/DeleteDialogueBox";
import Decrypt2 from "../../../helpers/Cryptography/CryptoJS";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import CommonConstants from "../../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";

const KnowledgeBaseMasterEdit = (props) => {
  let history = useHistory();
  // const { id: badgeId } = useParams();
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editModeIsActive, setEditModeIsActive] = useState(true);
  const [editModeDisableButton, setEditModeDisableButton] = useState(true);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [profileImageToBeDeleted, setProfileImageToBeDeleted] = useState(null);
  const [backgroundImageToBeDeleted, setBackgroundImageToBeDeleted] = useState(null);
  const [whichImageWantToDelete, setWhichImageWantToDelete] = useState(0);

  const [formErrors, setFormErrors] = useState({});
  const [Id, setId] = useState(0);

  const inputFileRef = useRef();
  const inputBackgroundFileRef = useRef();
  const [files, setFiles] = useState([]);
  const [backgroundFiles, setBackgroundFiles] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [isActive, setIsActive] = useState(true);
  let formErrorObj = {};
  let state_id = 0;

  const [allowedFileTypes, setAllowedFileTypes] = useState("");
  useEffect(() => {
    const allowedImagesFileTypesLS = getFromEncLocalStorage(
      "ImageFilesValidationExtension"
    );
    if (allowedImagesFileTypesLS) {
      setAllowedFileTypes(
        [...allowedImagesFileTypesLS.split(",")]
          .map((aift) => `.${aift}`)
          .join(",")
      );
    }
  }, []);

  useEffect(() => {
    (async () => {
      state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;
      if (state_id != 0 || state_id != "0") {
        getKnowledgeBaseMasterDataByIdApiCall(state_id);
      }
    })();
  }, []);

  const getKnowledgeBaseMasterDataByIdApiCall = async (id) => {
    setLoading(true);
    const data = await APICall(
      getKnowledgeBaseMasterDataById,
      { id: id },
      "POST"
    );

    if (data.message === "Ok") {
      if (data && data.data && data.data[0][0] && data.data[0][0].Id) {
        setId(data.data[0][0].Id);
        setName(data.data[0][0].Name);
        setDescription(data.data[0][0].Description);
        setIsActive(data.data[0][0].IsActive);
        setEditModeIsActive(false);
        setEditModeDisableButton(false);
        let dataArr = data.data[0];
        let dataObj = dataArr[0];
        setFiles(await getImageData(dataObj.ProfileImage));
        setBackgroundFiles(await getImageData(dataObj.BackgroundImage));
      }

      setLoading(false);
    } else {
      notify(1, data.message);
      setLoading(false);
    }
  };

  const getImageData = async (dbFile) => {
    let filesTmp = [];
    if (dbFile != null) {
      const fullResImgUrl = await downloadBlob(dbFile);
      const azureFileName = new URL(dbFile)?.pathname
        ?.split("/")
        ?.pop();
      filesTmp.push({
        localUrl: fullResImgUrl,
        blob: null,
        id: `img_0`,
        name: "",
        size: null,
        type: "",
        globalUrl: dbFile,
        azureFileName: azureFileName,
        exists: true,
      });
    }
    return filesTmp;
  };

  const onClickFunction = async (event, action) => {
    if (action === "Submit") {
      await checkValidations();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x === undefined
      );
      if (isEmpty) {
        setLoading(true);

        let filesTmp = await saveImage([...files]);
        setFiles(filesTmp);
        let backgroundFilesTmp = await saveImage([...backgroundFiles]);
        setBackgroundFiles(backgroundFilesTmp);

        let requestParams = {
          Id: Id,
          Name: name.replace(/\s+/g, " ").trim(),
          Description: description.replace(/\s+/g, " ").trim(),
          IsActive: isActive,
          ProfileFiles: filesTmp,
          BackgroundFiles: backgroundFilesTmp,
          CreatedDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
          UserId: getFromEncLocalStorage("userId"), //UserId
        };
        console.log(requestParams);

        const res = await APICall(
          insertUpdateKnowledgeBaseMaster,
          requestParams,
          "POST"
        );
        if (res.message === "Ok") {
          if (res && res.data !== 0) {
            if (Id === 0) {
              notify(0, saveRecordMsg);
            } else if (Id > 0) {
              notify(0, updateRecordMsg);
            }
            history.push({ pathname: "/knowledgebase-master" });
          }
          setLoading(false);
        } else {
          notify(1, res.message);
          setLoading(false);
        }
        setLoading(false);
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      history.push({ pathname: "/knowledgebase-master" });
    }
  };

  const resetFunction = () => {
    setFormErrors({});
    setName("");
    setDescription("");
    setFiles([]);
    setBackgroundFiles([]);
    formErrorObj = {};
  };

  const handleTextEvent = async (event, field) => {
    var error = undefined;
    let tempName = event.target.value;
    var setError = "";
    if (field === "name") {
      setName(tempName);
      setError = "Name";
    }
    if (field === "description") {
      setDescription(tempName);
      setError = "Description";
    }

    if (tempName == undefined || tempName == null || tempName.trim() == "") {
      error = setError + " Cannot Be Empty";
    }

    setFormErrors((preState) => ({
      ...preState,
      [setError.replaceAll(" ", "") + "_isEmpty"]: error,
    }));
  };

  const checkValidations = async () => {
    var objError = {};
    var setError = "";

    if (name == undefined || name == null || name.trim() == "") {
      setError = "Name";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Cannot Be Empty";
    } else if (name.replace(/\s+/g, " ").trim().length >= 50) {
      setError = "Name";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Is Longer Than The 50 Character";
    }
    // setDescription
    if (
      description == undefined ||
      description == null ||
      description.trim() == ""
    ) {
      setError = "Description";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Cannot Be Empty";
    } else if (description.replace(/\s+/g, " ").trim().length >= 500) {
      setError = "Description";
      objError[setError.replaceAll(" ", "") + "_isEmpty"] =
        setError + " Is Longer Than The 500 Character";
    }

    if (files.length <= 0) {
      objError["File_isEmpty"] = "Please Select Profile Image";
    }

    if (backgroundFiles.length <= 0) {
      objError["BackgroundFile_isEmpty"] = "Please Select Background Image";
    }

    formErrorObj = objError;
    await setFormErrors(objError);
  };

  const onFileChange = (e, field) => {
    if (
      [...e?.target?.files].filter((f) => !f.type.startsWith("image")).length >
      0
    ) {
      notify(1, "Only images is allowed!");
      return;
    }

    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size >= (500 * 1024 * 1024)) {
      notify(1, "Please select a file that is less than or equal to 5MB.");
      return;
    }

    let filesTmp = [];
    for (let index = 0; index < e?.target?.files?.length; index++) {
      const file = e?.target?.files?.[index];
      console.log(e?.target?.files);
      if (file) {
        filesTmp.push({
          localUrl: URL.createObjectURL(file),
          blob: file,
          id: `img_${index}`,
          name: file.name,
          size: file.size,
          type: file.type,
        });
      }
    }
    let valid = "";
    if (field === "profile_image") {
      setFiles(filesTmp);
      valid = "File";
    }
    if (field === "background_image") {
      setBackgroundFiles(filesTmp);
      valid = "BackgroundFile";
    }

    setFormErrors((preState) => ({
      ...preState,
      [valid + "_isEmpty"]: "",
    }));
  };

  const handleBtnClick = (e, field) => {
    if (field === "profile_image") {
      inputFileRef.current.click();
    }
    if (field === "background_image") {
      inputBackgroundFileRef.current.click();
    }
  };

  const deleteImage = async () => {
    whichImageWantToDelete == 1 ? setFiles([]) : setBackgroundFiles([])
    setShowDeleteConfirmationModal(false);
  };

  const saveImage = async (file) => {
    const formData = new FormData();
    for (let index = 0; index < file?.length; index++) {
      const filess = file?.[index];
      if (!filess?.globalUrl) {
        // let resp = await saveImage(filess.blob); //filess.blob
        formData.append("file", filess.blob);
        let resp = await CreateKnowledgeService.fileUpload(formData, "gallery");
        let imgUrl = resp?.result?.[0];
        if (imgUrl) {
          filess.globalUrl = imgUrl;
        }
      }
    }

    return file;
  };

  return (
    <>
      <Main active={"knowledgebase_master"} removeContainer={true}>
        <Loadspinner filename="KnowledgeBaseMasterEdit.js" isLoading={loading} isMiddle="false" />
        <div className="eventGalleryEdit">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "5px" }}>Master</h4>
              </div>
              <div className="clearfix"></div>
              <div
                className="d-flex align-items-center justify-space-between"
                style={{
                  background: "#e61636",
                  padding: "10px 20px 10px 10px",
                  color: "white",
                  width: "100%",
                }}
              >
                <div className="col-lg-8">Knowledge Base</div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">
                        Knowledge Base Name
                      </label> */}
                      <FormLabel value="Knowledge Base Name" />
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"Knowledge Base Name"}
                        isDisabled={editMode ? true : false}
                        textArea={false}
                        value={name}
                        onChange={(e) => handleTextEvent(e, "name")}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["Name_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["Name_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-4 col-xs-4 ">
                    <div className="form-group">
                      {/* <label className="col-form-label">Description</label> */}
                      <FormLabel value="Description" />
                      <sup>*</sup>
                      <InputForm
                        className="form-control form-control-sm"
                        placeholder={"Description"}
                        isDisabled={editMode ? true : false}
                        textArea={true}
                        value={description}
                        onChange={(e) => handleTextEvent(e, "description")}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["Description_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["Description_isEmpty"]} />
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-4 col-xs-4">
                    <div className="form-group">
                      {/* <label className="col-form-label">Active Status</label> */}
                      <FormLabel value="Active Status" />
                      <div className="custom-checkbox">
                        <input
                          disabled={editModeIsActive ? true : false}
                          type="checkbox"
                          onChange={(e) => setIsActive(e.target.checked)}
                          name="isActive"
                          checked={isActive}
                          className="isActive"
                          autoComplete={CommonConstants.autoCompleteInput}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 col-md-12 mt-3">
                  <div className="row">
                    <div className="col-lg-4 col-sm-4 col-xs-4">
                      {/* <label className="col-form-label">Profile Image</label> */}
                      <FormLabel value="Profile Image" />
                      <sup className="required">*</sup>
                      <InputGroup className="mb-3">
                        <InputForm
                          className="form-control form-control-sm fileInputStyle"
                          placeholder={"images"}
                          isDisabled={false}
                          textArea={false}
                          onClick={(e) => {
                            handleBtnClick(e, "profile_image");
                          }}
                          readOnly
                        />
                        <ButtonForm
                          variant="secondary"
                          id="button-addon2"
                          value="Browse"
                          onClick={(e) => {
                            handleBtnClick(e, "profile_image");
                          }}
                        />
                      </InputGroup>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        id="btn_event_gallery_master_file_input"
                        ref={inputFileRef}
                        onChange={(e) => {
                          onFileChange(e, "profile_image");
                        }}
                        accept={`${allowedFileTypes}`}
                        autoComplete={CommonConstants.autoCompleteInput}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["File_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["File_isEmpty"]} />
                    </div>
                    <div className="col-lg-4 col-sm-4 col-xs-4">
                      {/* <label className="col-form-label">Background Image</label> */}
                      <FormLabel value="Background Image" />
                      <sup className="required">*</sup>
                      <InputGroup className="mb-3">
                        <InputForm
                          className="form-control form-control-sm fileInputStyle"
                          placeholder={"images"}
                          isDisabled={false}
                          textArea={false}
                          onClick={(e) => {
                            handleBtnClick(e, "background_image");
                          }}
                          readOnly
                        />
                        <ButtonForm
                          variant="secondary"
                          id="button-addon2"
                          value="Browse"
                          onClick={(e) => {
                            handleBtnClick(e, "background_image");
                          }}
                        />
                      </InputGroup>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        id="btn_event_gallery_master_file_input"
                        ref={inputBackgroundFileRef}
                        onChange={(e) => {
                          onFileChange(e, "background_image");
                        }}
                        accept={`${allowedFileTypes}`}
                        autoComplete={CommonConstants.autoCompleteInput}
                      />
                      {/* <p style={{ color: "red" }}>
                        {formErrors["BackgroundFile_isEmpty"]}
                      </p> */}
                      <ErrorLabel value={formErrors["BackgroundFile_isEmpty"]} />
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 col-md-12 mt-3">
                  <div className="row">
                    <div className="col-lg-4 col-sm-4 col-xs-4">
                      {files?.map((file, fIdx) => {
                        //backgroundFiles
                        return (
                          <Card
                            key={`img${fIdx}`}
                            className="col-lg-6 col-sm-6 col-xs-6 imgCard"
                          >
                            <Card.Img
                              variant="top"
                              src={file?.localUrl}
                              className="gridImage"
                            />
                            <Card.Body className="imgCardBody">
                              <div className="row my-1">
                                <div className="col-lg-10 col-sm-10 col-xs-10 text-center">
                                  <Card.Text>{file?.azureFileName || file?.name}</Card.Text>
                                </div>
                                <div className="col-lg-2 col-sm-2 col-xs-2">
                                  <Button variant="outline-light" size="sm">
                                    <Image
                                      src={del}
                                      className="delBtn"
                                      onClick={() => {
                                        setProfileImageToBeDeleted(file);
                                        setWhichImageWantToDelete(1)
                                        setShowDeleteConfirmationModal(true);
                                      }}
                                    />
                                  </Button>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        );
                      })}
                    </div>

                    <div className="col-lg-4 col-sm-4 col-xs-4">
                      {backgroundFiles?.map((file, fIdx) => {
                        return (
                          <Card
                            key={`background${fIdx}`}
                            className="col-lg-6 col-sm-6 col-xs-6 imgCard"
                          >
                            <Card.Img
                              variant="top"
                              src={file?.localUrl}
                              className="gridImage"
                            />
                            <Card.Body className="imgCardBody">
                              <div className="row my-1">
                                <div className="col-lg-10 col-sm-10 col-xs-10 text-center">
                                  <Card.Text>{file?.name}</Card.Text>
                                </div>
                                <div className="col-lg-2 col-sm-2 col-xs-2">
                                  <Button variant="outline-light" size="sm">
                                    <Image
                                      src={del}
                                      className="delBtn"
                                      onClick={() => {
                                        setBackgroundImageToBeDeleted(file);
                                        setWhichImageWantToDelete(2)
                                        setShowDeleteConfirmationModal(true);
                                      }}
                                    />
                                  </Button>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-11 col-md-11" style={{ width: "97%" }}>
                    <div className="float-right">
                      <div className="float-right">
                        <SubmitButton onClick={(e) => onClickFunction(e, "Submit")} />
                        {editModeDisableButton && (
                          <ResetButton onClick={(e) => onClickFunction(e, "Reset")} />
                        )}

                        <CancelButton onClick={(e) => onClickFunction(e, "Cancel")} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Modal
          open={showDeleteConfirmationModal}
          onClose={() => setShowDeleteConfirmationModal(false)}
          className="modal-dialog modal-dialog-centered"
        >
          <div className="modal-content logout-modal">
            <div className="modal-body">
              Are you sure you want to delete this image?
            </div>
            <div className="display-row justify-space-evenly">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => {
                  whichImageWantToDelete == 1 ? setProfileImageToBeDeleted(null) : setBackgroundImageToBeDeleted(null)
                  setShowDeleteConfirmationModal(false);
                }}
              >
                Cancel
              </button>
             
              <button
                className="btn btn-danger"
                type="button"
                onClick={() => deleteImage(whichImageWantToDelete)}
              >
               
                Delete
              </button>
           
            </div>
          </div>
        </Modal> */}
        <DeleteDialogueBox
          open={showDeleteConfirmationModal}
          close={() => setShowDeleteConfirmationModal(false)}
          cancel={() => {
            whichImageWantToDelete == 1 ? setProfileImageToBeDeleted(null) : setBackgroundImageToBeDeleted(null)
            setShowDeleteConfirmationModal(false);
          }}
          deleteImage={() => deleteImage(whichImageWantToDelete)}

        />
      </Main>
    </>
  );
};

export default KnowledgeBaseMasterEdit;
